module.exports = __webpack_public_path__ + "fonts/lilitaone-regular-webfont.1305d321.ttf";